import { Reflink } from '../ReferralSystem/models/Reflink'
import { ReferralSystem } from '../ReferralSystem/models/ReferralSystem'
import { replaceUrlPattern } from '../Generic/models/UrlPattern/replaceUrlPattern'
import { Sampler } from '../util/src/sampler'

export const ensureReferralUrl = (systems: ReferralSystem[]) => (sampler: Sampler<Reflink>, system: ReferralSystem, reflinks: Reflink[]) => {

}

export const getReferralUrl = (sampler: Sampler<Reflink>, system: ReferralSystem, reflinks: Reflink[]) => {
  const reflink = getReflink(sampler, system, reflinks)
  const code = reflink ? reflink.code : ''
  return replaceUrlPattern(system.referralUrlPattern, { code })
}

function getReflink(sampler: Sampler<Reflink>, system: ReferralSystem, $reflinks: Reflink[]) {
  const reflinks = $reflinks.filter(r => r.system.id === system.id)
  return sampler(reflinks)
}
